<script setup lang="ts">
import { fetchProductImage } from '~~/services/ProductServices'
const props = defineProps<{
  url?: string
}>()

const image = ref<string | undefined>()

onMounted(() => {
  if (props.url) {
    const response = fetchProductImage(props.url)
    image.value = response.data?.publicUrl
  }
})
</script>
<template lang="pug">
div(v-if="image" class="bg-gray-100 relative h-full aspect-[9/8] shadow-line")
  img(
    :src="image"
    class="w-full h-full object-contain object-center mix-blend-multiply"
  )
</template>
